import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesServicesVideoFormMain } from './modules/ui/Main';

const ServicesVideoFormPage = (
  <SuspensePage>
    <PagesServicesVideoFormMain />
  </SuspensePage>
);

export default ServicesVideoFormPage;
